// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"01645749","805":"3d805c53"}[chunkId] + ".chunk.js";
};